import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import EventEmitter from 'utils/events';
import { EventEmitterTypes } from 'utils/constants';
import { IconButton, Grid } from '@material-ui/core';
import { MobileProgressBar } from 'components/common/ProgressBar/MobileProgressBar';
import { MoreVertOutlined } from '@material-ui/icons';

import Tooltip from 'components/common/Tooltip/Tooltip';
import { useTooltipTrigger } from '../../../../../utils/getTooltipTrigger/getTooltipTrigger';
import '../AssessmentNavBar.scss';

const useStyles = makeStyles({
  assessmentNavbarName: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    padding: '0.25rem 0rem 0.rem'
  },
  navbarName: {
    paddingLeft: '0.25rem'
  },
  assessmentName: {
    width: '99%'
  },
  moreIcon: {
    padding: '0.25rem',
    marginBottom: '0.25rem',
    color: '#176DC2'
  }
});

export function MobileAssessmentNavBar(props) {
  const { assessmentName, assessmentCompanyName, submitted, assessmentProgress } = props;
  const classes = useStyles();

  const companyNameRef = useRef();
  const assessmentNameRef = useRef();

  const showCompanyNameTooltip = useTooltipTrigger(companyNameRef);
  const showAssessmentNameTooltip = useTooltipTrigger(assessmentNameRef);

  const clickHandler = () => {
    EventEmitter.dispatch(EventEmitterTypes.TOGGLE_MOBILE_SIDEBAR, { right: 'right', open: true });
  };

  return (
    <div className="assessment-nav-bar">
      <div className={classes.assessmentNavbarName}>
        <Grid container spacing={0}>
          <Grid item xs={12} className={classes.navbarName}>
            <Tooltip disableTouchListener={!showCompanyNameTooltip} enterTouchDelay={0} leaveDelay={700} title={assessmentCompanyName}>
              <div ref={companyNameRef} className="name-prefix">
                {assessmentCompanyName}
              </div>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm container className={classes.navbarName}>
            <Grid item xs={11}>
              <Tooltip disableTouchListener={!showAssessmentNameTooltip} enterTouchDelay={0} leaveDelay={700} title={assessmentName}>
                <div ref={assessmentNameRef} className={`name ${classes.assessmentName}`}>
                  {assessmentName}
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={1}>
              {!submitted && (
                <div className="guided-tour-mobile-menu-wrapper">
                  <div className="guided-tour-mobile-menu" />
                  <IconButton onClick={clickHandler} className={classes.moreIcon} aria-label="more_vert">
                    <MoreVertOutlined />
                  </IconButton>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      {!submitted && (
        <div className="w-100">
          <MobileProgressBar progress={assessmentProgress} />
        </div>
      )}
    </div>
  );
}

export default MobileAssessmentNavBar;
